import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { Navbar, Nav, Container, NavDropdown } from "react-bootstrap";
import { logout } from "../Redux/Actions/AuthActions";
import logo from "../image/LOGOTASKOPOS1.png";
import "./NavAuth.css";

const NavAuth = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const user = useSelector((state) => state.AuthReducer?.user);
  const token = useSelector((state) => state.AuthReducer?.token);

  const path = (location.pathname || "").toLowerCase();
  const isPublicPage =
    path === "/login" ||
    path === "/welcome" ||
    path.startsWith("/caissemobile") ||
    path.startsWith("/reclamation") ||
    path.startsWith("/transfert-mobile") ||
    path.startsWith("/caisse-transfert");

  if (!token || !user || isPublicPage) {
    return null;
  }

  const handleLogout = () => {
    dispatch(logout());
    navigate("/welcome");
    setIsMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  // Visibility flags based on roles
  const isAdmin = user.role === 'admin' || user.role === 'useradmin';
  const isController = user.role === 'controleur' || (user.fonction && user.fonction.toLowerCase().includes('control'));
  const isControllerOrAdmin = isAdmin || isController;

  const canSeeCaisses = user.role === 'admin' || user.role === 'useradmin' || user.role === 'usertwinpark' || user.role === 'userbagngo' || user.role === 'userespace';
  const canSeeStockAndFactures = user.role === 'admin' || user.role === 'useradmin' || user.role === 'usertwinpark' || user.role === 'userbagngo' || user.role === 'userespace' || user.role === 'userspintoss';
  const canSeeAdminAnalytics = user.role === 'admin' || user.role === 'useradmin';
  const canSeeRapports = user.role === 'admin' || user.role === 'useradmin' || user.role === 'userwellness' || user.role === 'usertwinpark' || user.role === 'userspintoss';
  const canSeeAbonnements = user.role === 'admin' || user.role === 'usertwinpark' || user.role === 'userbagngo' || user.role === 'userespace' || user.role === 'userspintoss';

  return (
    <>
      <Navbar
        bg="dark"
        variant="dark"
        fixed="top"
        className="tasko-navbar"
        expand="xl"
        expanded={isMobileMenuOpen}
      >
        <Container fluid className="tasko-nav-container">
          {/* Logo */}
          <Navbar.Brand as={Link} to="/welcome" onClick={closeMobileMenu} className="d-flex align-items-center tasko-brand">
            <img
              src={logo}
              alt="TASKO POS"
              className="tasko-navbar-logo"
            />
          </Navbar.Brand>

          {/* Bouton hamburger */}
          <button
            className={`tasko-hamburger-btn ${isMobileMenuOpen ? 'active' : ''}`}
            onClick={toggleMobileMenu}
            aria-label="Menu"
          >
            <span className="tasko-hamburger-lines">
              <span className="tasko-line"></span>
              <span className="tasko-line"></span>
              <span className="tasko-line"></span>
            </span>
          </button>

          <Navbar.Collapse id="tasko-navbar-nav">
            <Nav className="tasko-nav-menu">
              {token && user ? (
                <>
                  {/* 1. ANALYTICS & FINANCES */}
                  {canSeeAdminAnalytics && (
                    <NavDropdown title="📊 Analytics & Finances" id="admin-analytics-dropdown" className="tasko-nav-dropdown">
                      <NavDropdown.Header>TABLEAUX DE BORD</NavDropdown.Header>
                      {(user.role === 'admin') && (
                        <NavDropdown.Item as={Link} to="/BrandStatsHub" onClick={closeMobileMenu} className="tasko-dropdown-item font-weight-bold text-primary">
                          🏢 Statistiques par Enseigne
                        </NavDropdown.Item>
                      )}
                      {user.role === 'admin' && (
                        <NavDropdown.Item as={Link} to="/Home" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          🏠 Menu Général / Dashboard
                        </NavDropdown.Item>
                      )}
                      {user.role === 'admin' && (
                        <NavDropdown.Item as={Link} to="/AdvancedAnalytics" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          📈 Analytics Avancés
                        </NavDropdown.Item>
                      )}
                      {user.role === 'admin' && (
                        <NavDropdown.Item as={Link} to="/GlobalDashbord" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          💰 Chiffre d'affaires
                        </NavDropdown.Item>
                      )}

                      <NavDropdown.Divider />
                      <NavDropdown.Header>FINANCES & MARGES</NavDropdown.Header>
                      {user.role === 'admin' && (
                        <NavDropdown.Item as={Link} to="/MargeState" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          📉 État de la Marge
                        </NavDropdown.Item>
                      )}
                      {user.role === 'admin' && (
                        <NavDropdown.Item as={Link} to="/AddChargeExp" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          💼 Charges d'exploitation
                        </NavDropdown.Item>
                      )}
                      {user.role === 'admin' && (
                        <NavDropdown.Item as={Link} to="/EtatDepenses" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          💸 État des Dépenses
                        </NavDropdown.Item>
                      )}
                      {user.role === 'admin' && (
                        <NavDropdown.Item as={Link} to="/Rbe" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          📊 Recap RBE
                        </NavDropdown.Item>
                      )}
                      {(user.role === 'admin' || user.role === 'useradmin') && (
                        <NavDropdown.Item as={Link} to="/TransfertsFonds" onClick={closeMobileMenu} className="tasko-dropdown-item font-weight-bold text-success">
                          💰 Transferts de Fonds & Monnaie
                        </NavDropdown.Item>
                      )}
                      {(user.role === 'admin' || user.role === 'useradmin') && (
                        <NavDropdown.Item as={Link} to="/ticketpersonnel" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          🍽️ Consommation Personnel
                        </NavDropdown.Item>
                      )}

                      <NavDropdown.Divider />
                      <NavDropdown.Header>STATISTIQUES PAR ENSEIGNE</NavDropdown.Header>
                      {user.role === 'admin' && (
                        <NavDropdown.Item as={Link} to="/Statistiques/Achats" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          📦 Statistiques Achats
                        </NavDropdown.Item>
                      )}
                      <NavDropdown.Item as={Link} to="/Statistiques/Wellness" onClick={closeMobileMenu} className="tasko-dropdown-item">
                        🧘 Wellness
                      </NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/Statistiques/Twinpark" onClick={closeMobileMenu} className="tasko-dropdown-item">
                        🎢 Twinpark
                      </NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/Statistiques/Bagngo" onClick={closeMobileMenu} className="tasko-dropdown-item">
                        🎒 Bagn'Go
                      </NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/Statistiques/Espace" onClick={closeMobileMenu} className="tasko-dropdown-item">
                        🏢 E-space
                      </NavDropdown.Item>
                      <NavDropdown.Item as={Link} to="/Statistiques/Spintoss" onClick={closeMobileMenu} className="tasko-dropdown-item">
                        🎯 Spintoss
                      </NavDropdown.Item>
                    </NavDropdown>
                  )}



                  {/* 2.bis ACHATS QUOTIDIENS */}
                  <NavDropdown title="🛍️ Achats Quotidiens" id="achats-quotidiens-dropdown" className="tasko-nav-dropdown">
                    <NavDropdown.Header>CAISSE & MES DEMANDES</NavDropdown.Header>
                    <NavDropdown.Item as={Link} to="/AchatsQuotidiens?tab=caisse" onClick={closeMobileMenu} className="tasko-dropdown-item font-weight-bold text-primary">
                      🛒 Caisse Demande d'Achat
                    </NavDropdown.Item>
                    <NavDropdown.Item as={Link} to="/AchatsQuotidiens?tab=suivi" onClick={closeMobileMenu} className="tasko-dropdown-item">
                      📦 Suivi de Mes Demandes
                    </NavDropdown.Item>

                    {isControllerOrAdmin && (
                      <>
                        <NavDropdown.Divider />
                        <NavDropdown.Header>GESTION & CONTRÔLE</NavDropdown.Header>
                        <NavDropdown.Item as={Link} to="/AchatsQuotidiens?tab=controle" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          📋 Validation & Contrôle
                        </NavDropdown.Item>
                        <NavDropdown.Item as={Link} to="/AchatsQuotidiens?tab=fournisseurs" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          ⚖️ Comparatif 3 Fournisseurs
                        </NavDropdown.Item>
                        <NavDropdown.Item as={Link} to="/AchatsQuotidiens?tab=factures" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          📑 Factures par Emplacement
                        </NavDropdown.Item>
                        <NavDropdown.Item as={Link} to="/AchatsQuotidiens?tab=cadence" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          📈 Cadence & Historique
                        </NavDropdown.Item>

                        <NavDropdown.Divider />
                        <NavDropdown.Header>NOMENCLATURE ARTICLES</NavDropdown.Header>
                        <NavDropdown.Item as={Link} to="/AchatsQuotidiens?tab=familles" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          ⚙️ Familles & Articles {user.role === 'admin' ? "(Gestion & Approbation)" : "(Gestion)"}
                        </NavDropdown.Item>
                      </>
                    )}
                  </NavDropdown>

                  {/* 3. STOCK & FACTURES */}
                  {canSeeStockAndFactures && (
                    <NavDropdown title="📦 Stock & Factures" id="stock-factures-dropdown" className="tasko-nav-dropdown">
                      {/* Demandes Produits */}
                      <NavDropdown.Header>DEMANDES & ACHATS</NavDropdown.Header>
                      <NavDropdown.Item as={Link} to="/ProductRequest" onClick={closeMobileMenu} className="tasko-dropdown-item">
                        📝 Demande Produits
                      </NavDropdown.Item>
                      {(user.role === 'admin' || user.role === 'useradmin') && (
                        <NavDropdown.Item as={Link} to="/CentralizedRequests" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          🔄 Centralisation Demandes
                        </NavDropdown.Item>
                      )}
                      {user.role === 'admin' && (
                        <NavDropdown.Item as={Link} to="/AdminApproval" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          ✅ Approbation Admin
                        </NavDropdown.Item>
                      )}
                      {(user.role === 'admin' || user.role === 'useradmin' || user.role === 'usertwinpark' || user.role === 'userbagngo') && (
                        <NavDropdown.Item as={Link} to="/PurchaseList" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          🛒 Liste d'Achat
                        </NavDropdown.Item>
                      )}

                      {/* Produits & Prix */}
                      {(user.role === 'admin' || user.role === 'useradmin') && (
                        <>
                          <NavDropdown.Divider />
                          <NavDropdown.Header>GESTION DES PRODUITS</NavDropdown.Header>
                          <NavDropdown.Item as={Link} to="/CreaValises" onClick={closeMobileMenu} className="tasko-dropdown-item">
                            ➕ Création Produits
                          </NavDropdown.Item>
                          <NavDropdown.Item as={Link} to="/UpdateProduct" onClick={closeMobileMenu} className="tasko-dropdown-item">
                            ✏️ Modification Produits
                          </NavDropdown.Item>
                          <NavDropdown.Item as={Link} to="/DealsV" onClick={closeMobileMenu} className="tasko-dropdown-item">
                            🏷️ Création des deals
                          </NavDropdown.Item>
                          <NavDropdown.Item as={Link} to="/CategoryProductManager" onClick={closeMobileMenu} className="tasko-dropdown-item">
                            📁 Catégorie & Produits WF
                          </NavDropdown.Item>
                          <NavDropdown.Item as={Link} to="/PointsGestionT" onClick={closeMobileMenu} className="tasko-dropdown-item">
                            ⭐ Gestion des points
                          </NavDropdown.Item>
                        </>
                      )}

                      {/* Stock & Localisation */}
                      {(user.role === 'admin' || user.role === 'useradmin') && (
                        <>
                          <NavDropdown.Divider />
                          <NavDropdown.Header>GESTION DU STOCK</NavDropdown.Header>
                          <NavDropdown.Item as={Link} to="/StockDetails" onClick={closeMobileMenu} className="tasko-dropdown-item">
                            👀 Aperçu du Stock
                          </NavDropdown.Item>
                          <NavDropdown.Item as={Link} to="/ApercuStock" onClick={closeMobileMenu} className="tasko-dropdown-item">
                            📊 État du Stock
                          </NavDropdown.Item>
                          <NavDropdown.Item as={Link} to="/UpdateStockV" onClick={closeMobileMenu} className="tasko-dropdown-item">
                            🔄 Modification Stock
                          </NavDropdown.Item>
                          <NavDropdown.Item as={Link} to="/ChangeLocation" onClick={closeMobileMenu} className="tasko-dropdown-item">
                            📍 Changement de Localisation
                          </NavDropdown.Item>
                        </>
                      )}

                      {/* Factures & OCR */}
                      {(user.role === 'admin' || user.role === 'useradmin' || user.role === 'usertwinpark' || user.role === 'userbagngo' || user.role === 'userespace') && (
                        <>
                          <NavDropdown.Divider />
                          <NavDropdown.Header>FACTURES & FOURNISSEURS</NavDropdown.Header>
                          {(user.role === 'admin' || user.role === 'useradmin') && (
                            <NavDropdown.Item as={Link} to="/AjoutFrsV" onClick={closeMobileMenu} className="tasko-dropdown-item">
                              🚚 Ajouter un fournisseur
                            </NavDropdown.Item>
                          )}
                          {(user.role === 'admin' || user.role === 'useradmin') && (
                            <NavDropdown.Item as={Link} to="/AjoutFactureV" onClick={closeMobileMenu} className="tasko-dropdown-item">
                              📄 Ajouter une facture
                            </NavDropdown.Item>
                          )}
                          {(user.role === 'admin' || user.role === 'useradmin') && (
                            <NavDropdown.Item as={Link} to="/ListFactureV" onClick={closeMobileMenu} className="tasko-dropdown-item">
                              📋 Liste des factures
                            </NavDropdown.Item>
                          )}
                          <NavDropdown.Item as={Link} to="/UploadInvoice" onClick={closeMobileMenu} className="tasko-dropdown-item">
                            📤 Scannage / Téléchargement
                          </NavDropdown.Item>
                          {(user.role === 'admin' || user.role === 'useradmin') && (
                            <NavDropdown.Item as={Link} to="/InvoiceDocList" onClick={closeMobileMenu} className="tasko-dropdown-item">
                              📑 Listing des factures OCR
                            </NavDropdown.Item>
                          )}
                          {user.role === 'admin' && (
                            <NavDropdown.Item as={Link} to="/InvoiceView" onClick={closeMobileMenu} className="tasko-dropdown-item">
                              🔍 Aperçu des factures
                            </NavDropdown.Item>
                          )}
                        </>
                      )}
                    </NavDropdown>
                  )}

                  {/* 2. CAISSES */}
                  {canSeeCaisses && (
                    <NavDropdown title="🛒 Caisses" id="caisses-dropdown" className="tasko-nav-dropdown">
                      {(user.role === 'admin' || user.role === 'useradmin') && (
                        <NavDropdown.Item as={Link} to="/CaisseMobile" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          📱 Caisse Tactile
                        </NavDropdown.Item>
                      )}
                      {(user.role === 'admin' || user.role === 'usertwinpark' || user.role === 'userbagngo' || user.role === 'userespace') && (
                        <NavDropdown.Item as={Link} to="/Valises" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          💻 Caisse Classique
                        </NavDropdown.Item>
                      )}
                      {(user.role === 'admin' || user.role === 'usertwinpark' || user.role === 'userbagngo' || user.role === 'userespace') && (
                        <NavDropdown.Item as={Link} to="/TicketCaisse" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          📄 Rapport de caisse
                        </NavDropdown.Item>
                      )}
                      <NavDropdown.Item as={Link} to="/TransfertsFonds" onClick={closeMobileMenu} className="tasko-dropdown-item font-weight-bold text-success">
                        💰 Transferts de Fonds & Monnaie
                      </NavDropdown.Item>
                      {(user.role === 'admin' || user.role === 'useradmin') && (
                        <NavDropdown.Item as={Link} to="/GestionRemises" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          🏷️ Configuration Remises
                        </NavDropdown.Item>
                      )}
                    </NavDropdown>
                  )}

                  {/* 4. RAPPORTS */}
                  {canSeeRapports && (
                    <NavDropdown title="📋 Rapports" id="rapports-dropdown" className="tasko-nav-dropdown">
                      {(user.role === 'admin' || user.role === 'userwellness') && (
                        <>
                          <NavDropdown.Header>WELLNESS</NavDropdown.Header>
                          <NavDropdown.Item as={Link} to="/AddRapports" onClick={closeMobileMenu} className="tasko-dropdown-item">
                            ➕ Nouveau Rapport Wellness
                          </NavDropdown.Item>
                          {user.role === 'admin' && (
                            <NavDropdown.Item as={Link} to="/ListRapport" onClick={closeMobileMenu} className="tasko-dropdown-item">
                              📋 Liste Rapports Wellness
                            </NavDropdown.Item>
                          )}
                        </>
                      )}

                      {(user.role === 'admin' || user.role === 'usertwinpark') && (
                        <>
                          <NavDropdown.Divider />
                          <NavDropdown.Header>TWIN PARK</NavDropdown.Header>
                          <NavDropdown.Item as={Link} to="/AddRapportsTwin" onClick={closeMobileMenu} className="tasko-dropdown-item">
                            ➕ Nouveau Rapport Twin Park
                          </NavDropdown.Item>
                          {user.role === 'admin' && (
                            <NavDropdown.Item as={Link} to="/ListeRapportsTwin" onClick={closeMobileMenu} className="tasko-dropdown-item">
                              📋 Liste Rapports Twin Park
                            </NavDropdown.Item>
                          )}
                          <NavDropdown.Item as={Link} to="/CollecteTwin" onClick={closeMobileMenu} className="tasko-dropdown-item">
                            💵 Collecte Twin Park
                          </NavDropdown.Item>
                          {user.role === 'admin' && (
                            <NavDropdown.Item as={Link} to="/ListeCollecteTwin" onClick={closeMobileMenu} className="tasko-dropdown-item">
                              📋 Liste Collectes Twin Park
                            </NavDropdown.Item>
                          )}
                        </>
                      )}

                      {(user.role === 'admin' || user.role === 'userspintoss') && (
                        <>
                          <NavDropdown.Divider />
                          <NavDropdown.Header>SPINTOSS</NavDropdown.Header>
                          <NavDropdown.Item as={Link} to="/AddRapportsSpintoss" onClick={closeMobileMenu} className="tasko-dropdown-item">
                            ➕ Nouveau Rapport Spintoss
                          </NavDropdown.Item>
                          {user.role === 'admin' && (
                            <NavDropdown.Item as={Link} to="/ListRapportsSpintoss" onClick={closeMobileMenu} className="tasko-dropdown-item">
                              📋 Liste Rapports Spintoss
                            </NavDropdown.Item>
                          )}
                        </>
                      )}

                      {(user.role === 'admin' || user.role === 'useradmin') && (
                        <>
                          <NavDropdown.Divider />
                          <NavDropdown.Header>RESSOURCES HUMAINES</NavDropdown.Header>
                          <NavDropdown.Item as={Link} to="/DeclarationEmployeur" onClick={closeMobileMenu} className="tasko-dropdown-item">
                            📄 Déclaration Employeur
                          </NavDropdown.Item>
                        </>
                      )}
                    </NavDropdown>
                  )}

                  {/* 5. ABONNEMENTS */}
                  {canSeeAbonnements && (
                    <NavDropdown title="🎟️ Abonnements" id="abonnements-dropdown" className="tasko-nav-dropdown">
                      <NavDropdown.Item as={Link} to="/Event" onClick={closeMobileMenu} className="tasko-dropdown-item">
                        📢 Actions Marketing
                      </NavDropdown.Item>
                      {user.role === 'admin' && (
                        <NavDropdown.Item as={Link} to="/Pack" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          📦 Gestion des packages
                        </NavDropdown.Item>
                      )}
                      {(user.role === 'admin' || user.role === 'usertwinpark' || user.role === 'userespace' || user.role === 'userspintoss') && (
                        <NavDropdown.Item as={Link} to="/Checkin" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          ✅ Vérification pack
                        </NavDropdown.Item>
                      )}
                      {user.role === 'admin' && (
                        <NavDropdown.Item as={Link} to="/SubscribersList" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          👥 Liste des abonnés
                        </NavDropdown.Item>
                      )}
                    </NavDropdown>
                  )}

                  {/* 6. GESTION & PROFIL */}
                  <NavDropdown title="⚙️ Profil & Config" id="profile-dropdown" className="tasko-nav-dropdown">
                    <NavDropdown.Header>GESTION & SUIVI</NavDropdown.Header>
                    <NavDropdown.Item as={Link} to="/GestionQR" onClick={closeMobileMenu} className="tasko-dropdown-item">
                      📱 {user.role === 'admin' || user.role === 'useradmin' ? 'QR & Réclamations' : '⚠️ Réclamations du Site'}
                    </NavDropdown.Item>
                    {(user.role === 'admin' || user.role === 'useradmin') && (
                      <>
                        <NavDropdown.Item as={Link} to="/GestionCaissiers" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          👤 Gestion Caissiers & PIN
                        </NavDropdown.Item>
                        <NavDropdown.Item as={Link} to="/GestionAgentsTransfert" onClick={closeMobileMenu} className="tasko-dropdown-item font-weight-bold text-primary">
                          🔄 Agents de Transfert & PIN
                        </NavDropdown.Item>
                        <NavDropdown.Item as={Link} to="/GestionEmplacements" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          📍 Emplacements & Voitures
                        </NavDropdown.Item>
                        <NavDropdown.Item as={Link} to="/GestionEmplacements" onClick={closeMobileMenu} className="tasko-dropdown-item font-weight-bold text-success">
                          📡 Caisses NFC & QR Codes
                        </NavDropdown.Item>
                      </>
                    )}
                    {user.role === 'admin' && (
                      <>
                        <NavDropdown.Item as={Link} to="/AllUser" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          👥 Tous les utilisateurs
                        </NavDropdown.Item>
                        <NavDropdown.Item as={Link} to="/Register" onClick={closeMobileMenu} className="tasko-dropdown-item">
                          ➕ Inscrire un utilisateur
                        </NavDropdown.Item>
                      </>
                    )}
                    <NavDropdown.Divider />
                    <NavDropdown.Header>MON COMPTE</NavDropdown.Header>
                    <NavDropdown.Item as={Link} to="/UpdateProfil" onClick={closeMobileMenu} className="tasko-dropdown-item">
                      🔑 Modifier Mot de Passe
                    </NavDropdown.Item>
                  </NavDropdown>

                  {/* 7. DÉCONNEXION */}
                  <Nav.Link onClick={handleLogout} className="tasko-nav-link tasko-logout-link">
                    🚪 Déconnexion
                  </Nav.Link>
                </>
              ) : (
                <>
                  <Nav.Link as={Link} to="/welcome" onClick={closeMobileMenu} className="tasko-nav-link">
                    Welcome TASKO POS
                  </Nav.Link>
                  <Nav.Link as={Link} to="/Login" onClick={closeMobileMenu} className="tasko-nav-link">
                    Login
                  </Nav.Link>
                </>
              )}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Overlay pour mobile */}
      {isMobileMenuOpen && (
        <div className="tasko-mobile-overlay" onClick={closeMobileMenu}></div>
      )}
    </>
  );
};

export default NavAuth;